(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-glasses-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const EPS = 1e-9;
  const AXIS_RE = /^[0-9]{1,3}$/;
  const axisOk = (s) => AXIS_RE.test(String(s).trim()) && Number(s) >= 1 && Number(s) <= 180;
  function axisClean(input) {
    const raw = input.value; const digits = raw.replace(/[^0-9]/g, '').slice(0, 3);
    if (digits !== raw) input.value = digits;
    const box = input.closest('.pxg-in'), er = box && box.querySelector('[data-axerr]');
    let m = '';
    if (raw !== digits) m = '軸度只能填整數 1–180，不可填負數或小數。';
    else if (digits !== '' && !axisOk(digits)) m = '軸度請填 1–180 的整數。';
    if (er) er.textContent = m; input.setAttribute('aria-invalid', m ? 'true' : 'false');
    return m === '';
  }
  document.addEventListener('input', (e) => { const t = e.target; if (t instanceof HTMLInputElement && t.matches('[data-rx=axis],[data-f=axis]')) axisClean(t); }, true);
  document.addEventListener('beforeinput', (e) => { const t = e.target; if (t instanceof HTMLInputElement && t.matches('[data-rx=axis],[data-f=axis]') && e.data && /[^0-9]/.test(e.data)) { e.preventDefault(); const er = t.closest('.pxg-in').querySelector('[data-axerr]'); if (er) er.textContent = '軸度只能填整數 1–180，不可填負數或小數。'; t.setAttribute('aria-invalid', 'true'); } }, true);
  // 資訊「!」：點擊／觸控切換，滑鼠移入顯示；Esc 與點外面關閉
  (function () {
    const close = (b) => { b.setAttribute('aria-expanded', 'false'); const tip = document.getElementById(b.getAttribute('aria-controls')); if (tip) tip.hidden = true; };
    const open = (b) => { document.querySelectorAll('.pxg-info[aria-expanded=true]').forEach((x) => x !== b && close(x)); b.setAttribute('aria-expanded', 'true'); const tip = document.getElementById(b.getAttribute('aria-controls')); if (tip) tip.hidden = false; };
    document.addEventListener('click', (e) => {
      const b = e.target instanceof Element ? e.target.closest('.pxg-info') : null;
      if (b) { e.preventDefault(); e.stopPropagation(); b.getAttribute('aria-expanded') === 'true' ? close(b) : open(b); return; }
      document.querySelectorAll('.pxg-info[aria-expanded=true]').forEach(close);
    }, true);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') document.querySelectorAll('.pxg-info[aria-expanded=true]').forEach((b) => { close(b); b.focus(); }); });
    if (window.matchMedia('(hover:hover)').matches) {
      document.addEventListener('mouseover', (e) => { const b = e.target instanceof Element ? e.target.closest('.pxg-info') : null; if (b && b.getAttribute('aria-expanded') !== 'true') { open(b); b.dataset.hov = '1'; } }, true);
      document.addEventListener('mouseout', (e) => { const b = e.target instanceof Element ? e.target.closest('.pxg-info') : null; if (b && b.dataset.hov === '1' && !(e.relatedTarget && b.contains(e.relatedTarget))) { close(b); delete b.dataset.hov; } }, true);
    }
  })();
  const CYLS = [0.75, 1.25, 1.75];
  function toD(raw) {
    if (raw == null) return null;
    let s = String(raw).trim().replace(/[度°dD\s]/g, '').replace(/[－−]/g, '-').replace(/＋/g, '+').replace(/，/g, '.');
    if (s === '' || s === '-' || s === '+') return null;
    const n = Number(s);
    if (!Number.isFinite(n)) return NaN;
    const a = Math.abs(n);
    const v = (!s.includes('.') && a >= 20) ? a / 100 : a;
    return { mag: v, plus: s.startsWith('+') };
  }
  const f1 = (d) => d.toFixed(d * 4 % 2 === 0 ? 1 : 2);
  const D = (d) => (d === 0 ? '0D' : `-${f1(d)}D`);

  function init(root) {
    const calc = root.querySelector('[data-pxg-calc]');
    if (!calc || calc.dataset.ready) return;
    calc.dataset.ready = '1';
    const data = JSON.parse(calc.querySelector('[data-pxg-options]').textContent);
    const vPlain = data.values.find((v) => v.includes('平光'));
    const vAst = data.values.find((v) => v.includes('散光'));
    const vMy = data.values.find((v) => v.includes('近視') && !v.includes('散光'));
    const pdMin = Number(root.dataset.pdMin) || 0;
    const PD_LO = 40, PD_HI = 80;
    // PD 規則：CP-823 系列（SABLE 官網：無法製作 PD 62 以下）需大於 62；其餘款式採成人實用範圍 40–80mm
    function pdErr(v) {
      if (v === null || v === undefined) return '請填瞳距 PD（mm），例如 64。';
      if (!Number.isFinite(v)) return 'PD 請填數字（mm），例如 64。';
      if (pdMin && v <= pdMin + EPS) return `PD 需大於 ${pdMin}mm，例如 64（此款無法製作 PD ${pdMin}mm 以下的鏡片；您填的是 ${v}mm）。`;
      if (v < PD_LO || v > PD_HI) return `PD 需在 ${PD_LO}–${PD_HI}mm 之間（這是本站的輸入範圍），您填的是 ${v}mm。請對照驗光單上的 PD 值，例如 64。`;
      return '';
    }
    function blockBtn(b) {
      if (!b || !b.classList) return;
      b.classList.remove('pxg-shake'); void b.offsetWidth; b.classList.add('pxg-shake');
      setTimeout(() => b.classList.remove('pxg-shake'), 600);
    }
    const msg = calc.querySelector('[data-msg]'), btn = calc.querySelector('[data-apply]');
    const res = calc.querySelector('[data-res]'), memoEl = calc.querySelector('[data-memo]'), varEl = calc.querySelector('[data-variant]');
    let pick = null, last = null;

    function eyeCalc(fs) {
      const val = (k) => fs.querySelector(`[data-f=${k}]`).value;
      const sph = toD(val('sph')), cyl = toD(val('cyl'));
      const axWrap = fs.querySelector('[data-f-axis-wrap]'); const axIn = fs.querySelector('[data-f=axis]');
      if (axWrap) { const showAx = !!(cyl && typeof cyl === 'object' && cyl.mag > 0); axWrap.hidden = !showAx; if (!showAx && axIn.value) { axIn.value = ''; const er = axWrap.querySelector('[data-axerr]'); if (er) er.textContent = ''; axIn.setAttribute('aria-invalid', 'false'); } }
      const axisRaw = val('axis').trim();
      const out = fs.querySelector('[data-out]');
      if (sph === null && (cyl === null || cyl.mag === 0)) { out.innerHTML = '請輸入近視度數（平光請填 0）'; return null; }
      if ((sph && Number.isNaN(sph)) || (cyl && Number.isNaN(cyl))) { out.innerHTML = '<em>請輸入數字，例如 450 或 -4.50</em>'; return { err: 1 }; }
      if (sph && sph.plus && sph.mag > 0) { out.innerHTML = '<em>運動眼鏡不提供遠視鏡片，請洽 SABLE 配合門市。</em>'; return { err: 1 }; }
      let s = sph ? sph.mag : 0, c = cyl ? cyl.mag : 0, note = '', ast = 0, axis = null, err = 0;
      if (c > EPS && c < 0.75 - EPS) {
        // 散光 0.25–0.50D：不在散光選項內，以等效球面（近視 + 散光 ÷ 2）併入近視度數。
        s = s + c / 2; note = `散光 -${c.toFixed(2)}D 未達 -0.75D，以近視 + 散光 ÷ 2 估算`; c = 0;
      }
      if (c >= 0.75 - EPS) {
        if (c > 1.75 + 0.25 + EPS) { note = `散光 -${c.toFixed(2)}D 超過本款可選的 -1.75D 上限，請先洽詢客服或驗光師。若改以「近視 + 散光 ÷ 2」換算，只是近似，殘留散光可能造成重影、變形與夜間模糊，不建議長期使用`; err = 1; }
        ast = CYLS.reduce((b, x) => (Math.abs(x - c) < Math.abs(b - c) - EPS ? x : b), CYLS[0]);
        if (Math.abs(ast - c) > EPS && !err) note = c > 1.75 + EPS ? `散光 -${c.toFixed(2)}D 超過最高選項 -1.75D，暫以 -1.75D 估算，請先洽詢客服或驗光師確認` : `散光 -${c.toFixed(2)}D 不在選項內，建議 ${D(ast)}，請與驗光師確認`;
        if (!axisOk(axisRaw)) { note = (note ? note + '；' : '') + '請填軸度（1–180 的整數）'; err = err || 2; } else axis = Number(axisRaw);
      }
      let sp = 0;
      if (s > EPS) {
        if (s < 1.0 - EPS) { sp = ast ? 1.0 : 0; note = (note ? note + '；' : '') + (ast ? '近視未達 -1.0D，以 -1.0D 估算，請先諮詢驗光師' : '近視未達 -1.0D，建議平光'); }
        else if (s > 8.0 + EPS) { sp = 8.0; note = '超過 -8.0D，無法製作，請洽 SABLE 配合門市'; err = 1; }
        else sp = Math.floor(s * 2 + EPS) / 2; // 每 0.5D 一階，取最接近且較低的度數
        if (sp && Math.abs(sp - s) > EPS && !err && s >= 1.0 - EPS) note = (note ? note + '；' : '') + `${D(s).replace(/0+D$/, 'D')} 介於兩階之間，取較低的 ${D(sp)}`;
      } else if (ast) { sp = 0; }
      const label = ast ? `近視 ${D(sp)}・散光 ${D(ast)}・軸度 ${axis ?? '—'}` : (sp ? `近視 ${D(sp)}` : '平光');
      out.innerHTML = `<b>${label}</b>` + (note ? `<em>${note}</em>` : '');
      return { sp, ast, axis, err };
    }

    function run() {
      pick = null; res.hidden = true; msg.textContent = '';
      const r = {};
      for (const fs of calc.querySelectorAll('.pxg-eye')) r[fs.dataset.eye] = eyeCalc(fs);
      const pdRaw = calc.querySelector('[data-f=pd]').value.trim();
      const pd = pdRaw === '' ? null : Number(pdRaw.replace(/[mM\s]/g, ''));
      if (!r.L || !r.R || r.L.err || r.R.err) { btn.disabled = true; return; }
      if (pd !== null) { const pe = pdErr(pd); if (pe) { msg.textContent = pe; btn.disabled = true; return; } }
      const any = (k) => r.L[k] || r.R[k];
      pick = any('ast') ? vAst : (any('sp') ? vMy : vPlain);
      const eye = (n, e) => e.ast ? `${n} 近視 ${D(e.sp)} 散光 ${D(e.ast)} 軸度 ${e.axis}` : `${n} 近視 ${D(e.sp)}`;
      varEl.textContent = pick || '—';
      if (pick === vPlain) { memoEl.textContent = '平光，免填度數'; }
      else memoEl.textContent = `${eye('右眼', r.R)}；${eye('左眼', r.L)}；PD ${pd ?? '（請填）'}mm`;
      if (pick !== vPlain && pd === null) msg.textContent = '請填瞳距 PD（mm），例如 64。';
      res.hidden = false;
      btn.disabled = !pick;
      last = { r, pd };
    }

    function picker() {
      const pid = root.dataset.productId;
      return document.querySelector(`variant-picker[data-product-id="${pid}"][data-template-product-match="true"]`) || document.querySelector(`variant-picker[data-product-id="${pid}"]`);
    }
    function formId() {
      const f = document.querySelector(`form[data-product-id="${root.dataset.productId}"] input[name="id"]`) || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return f ? f.value : null;
    }
    async function setOption(name, value) {
      const vp = picker(); if (!vp) return false;
      const before = formId();
      const radio = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === name && i.value === value);
      if (radio) { if (radio.checked) return true; radio.click(); }
      else {
        const sel = [...vp.querySelectorAll('select')].find((s) => s.name === `options[${name}]`);
        if (!sel) return false; if (sel.value === value) return true;
        sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const t0 = Date.now();
      while (formId() === before && Date.now() - t0 < 5000) await new Promise((r) => setTimeout(r, 100));
      return true;
    }

    // ---- 直接選擇度數（左右眼）→ 度數選項 + 訂單屬性 ----
    const rx = {};
    (function () {
      const box = root.querySelector('[data-pxg-rx]'); if (!box) return;
      rx.box = box;
      const rmsg = box.querySelector('[data-rx-msg]'), props = box.querySelector('[data-rx-props]');
      const pdIn = box.querySelector('[data-rx=pd]');
      const eyes = {};
      box.querySelectorAll('[data-rx-eye]').forEach((fs) => { eyes[fs.dataset.rxEye] = { fs, name: fs.dataset.name, sph: fs.querySelector('[data-rx=sph]'), cyl: fs.querySelector('[data-rx=cyl]'), axis: fs.querySelector('[data-rx=axis]'), wrap: fs.querySelector('[data-rx-axis-wrap]'), sur: fs.querySelector('[data-sur]') }; });
      const num = (v) => (v === '' ? null : Math.abs(parseFloat(v)));
      const fmt = (d) => `-${f1(d)}D`;
      const NT = (c) => 'NT$' + Math.round(c / 100).toLocaleString('en-US');
      let V = null; try { V = JSON.parse(root.querySelector('[data-pxg-variants]').textContent); } catch (_) {}
      const hasAst = !!vAst && !!vMy;
      function state() {
        const o = {};
        for (const k of ['R', 'L']) { const e = eyes[k]; o[k] = { sphSet: e.sph.value !== '', sph: e.sph.value === '' || e.sph.value === '0' ? 0 : num(e.sph.value), sphTxt: e.sph.value, cyl: e.cyl.value, axis: e.axis.value.trim() }; }
        o.pd = pdIn.value.trim() === '' ? null : Number(pdIn.value);
        o.anyCyl = !!(o.R.cyl || o.L.cyl);
        return o;
      }
      function curRx() {
        const vp = picker(); if (!vp) return null;
        const r = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === data.name && i.checked);
        if (r) return r.value;
        const sel = [...vp.querySelectorAll('select')].find((x) => x.name === `options[${data.name}]`);
        return sel ? sel.value : null;
      }
      function selection() {
        const s = {}; const vp = picker(); if (!vp || !V) return s;
        V.names.forEach((n) => {
          const r = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === n && i.checked);
          if (r) { s[n] = r.value; return; }
          const sel = [...vp.querySelectorAll('select')].find((x) => x.name === `options[${n}]`); s[n] = sel ? sel.value : null;
        });
        return s;
      }
      function priceOf(s) { if (!V) return null; const v = V.v.find((x) => V.names.every((n, i) => x.o[i] === s[n])); return v ? v.p : null; }
      function mainForm() { return document.querySelector(`form[data-type="add-to-cart-form"]`) || document.querySelector('form[action*="/cart/add"]'); }
      function eyeLine(n, e) { return e.cyl ? `${n}：近視 ${e.sph ? fmt(e.sph) : '0'}／散光 ${e.cyl}／軸度 ${e.axis || '—'}` : `${n}：${e.sph ? '近視 ' + fmt(e.sph) : (e.sphSet ? '平光' : '尚未選擇')}`; }
      function writeProps(o, plain) {
        props.innerHTML = '';
        const fm = mainForm(); const fid = fm ? fm.getAttribute('id') : '';
        const add = (k, v) => { if (v === '' || v == null) return; const i = document.createElement('input'); i.type = 'hidden'; i.name = `properties[${k}]`; i.value = v; if (fid) i.setAttribute('form', fid); props.appendChild(i); };
        if (plain) return;
        for (const k of ['R', 'L']) { const e = o[k], n = eyes[k].name; add(`${n}近視`, e.sph ? fmt(e.sph) : '平光'); if (e.cyl) { add(`${n}散光`, e.cyl); add(`${n}軸度`, e.axis); } }
        add('瞳距 PD', o.pd != null ? `${o.pd}mm` : '');
      }
      let errEl = null;
      const pdBox = pdIn.closest('.pxg-in'), pdEr = pdBox.querySelector('[data-pderr]');
      function pdInline(m) { pdEr.textContent = m || ''; pdIn.setAttribute('aria-invalid', m ? 'true' : 'false'); }
      function update() {
        for (const k of ['R', 'L']) { const e = eyes[k]; const has = !!e.cyl.value; e.wrap.hidden = !has; e.axis.disabled = !has; if (!has) { e.axis.value = ''; const er = e.wrap.querySelector('[data-axerr]'); if (er) er.textContent = ''; e.axis.setAttribute('aria-invalid', 'false'); } }
        const o = state(); const plain = curRx() === vPlain;
        writeProps(o, plain || !(o.R.sphSet && o.L.sphSet));
        rmsg.textContent = '';
        if (rx.render) rx.render();
        return o;
      }
      // 度數選項（平光／近視／近視＋散光）改變時，左右眼欄位跟著變
      let lastRx;
      function applyMode() {
        const c = curRx(); if (c === lastRx) return; lastRx = c;
        if (c === vPlain) {
          for (const k of ['R', 'L']) { const e = eyes[k]; e.sph.value = ''; e.cyl.value = ''; e.axis.value = ''; }
          pdIn.value = ''; pdInline(''); rmsg.textContent = '';
        } else if (c === vMy) {
          for (const k of ['R', 'L']) { const e = eyes[k]; e.cyl.value = ''; e.axis.value = ''; }
        }
        update();
      }
      rx.applyMode = applyMode;
      // 規格由左右眼選擇決定：有散光＝近視＋散光；全部「無」＝近視；兩眼皆平光＝平光
      async function sync() {
        const o = update();
        if (curRx() === vPlain) return;
        let w = o.anyCyl ? (vAst || vMy) : (vMy || vAst);
        if (!o.anyCyl && o.R.sphSet && o.L.sphSet && !o.R.sph && !o.L.sph && vPlain) w = vPlain;
        if (w && w !== curRx()) await setOption(data.name, w);
        applyMode(); update();
      }
      rx.sync = sync;
      function eyesErr() {
        const o = state();
        if (!(o.R.sphSet && o.L.sphSet)) { errEl = !o.R.sphSet ? eyes.R.sph : eyes.L.sph; return '請選擇右眼與左眼的近視度數（沒有度數請選「平光（0）」）。'; }
        for (const k of ['R', 'L']) { const e = o[k]; if (e.cyl && !axisOk(e.axis)) { errEl = eyes[k].axis; return `請填${eyes[k].name}的軸度（1–180）。`; } }
        return '';
      }
      // ---- 完成選配閘門：鏡片、鏡框顏色、度數類型要親自選過；近視要選左右眼度數（有散光要填軸度）並填 PD ----
      const gate = { cfg: false, t: { lens: true, color: true, rx: true }, last: null };
      const STEP_LBL = { lens: '請先選擇鏡片', color: '請先選擇鏡框顏色', rx: '請先選擇度數類型' };
      function gateStatus() {
        if (gate.cfg) for (const k of ['lens', 'color', 'rx']) if (!gate.t[k]) return { ok: false, step: k, label: STEP_LBL[k], msg: STEP_LBL[k] + '，再加入購物車。', el: steps[k].hd };
        const o = state(); const cur = curRx();
        if (cur === vPlain) return { ok: true };
        if (!(o.R.sphSet && o.L.sphSet)) return { ok: false, step: 'eyes', label: '請先選擇左右眼度數', msg: '請選擇右眼與左眼的近視度數（沒有度數請選「平光（0）」）。', el: !o.R.sphSet ? eyes.R.sph : eyes.L.sph };
        for (const k of ['R', 'L']) { const e = o[k]; if (e.cyl && !axisOk(e.axis)) return { ok: false, step: 'eyes', label: '請先填散光軸度', msg: `請填${eyes[k].name}的軸度（1–180）。`, el: eyes[k].axis }; }
        const pe = pdErr(o.pd);
        if (pe) return { ok: false, step: 'pd', label: o.pd == null || !Number.isFinite(o.pd) ? '請先填瞳距 PD' : (pdMin ? `PD 需大於 ${pdMin}mm` : `PD 需在 ${PD_LO}–${PD_HI}mm`), msg: pe, el: pdIn };
        const w = o.anyCyl ? (vAst || vMy) : (vMy || vAst);
        const w2 = (!o.anyCyl && o.R.sphSet && o.L.sphSet && !o.R.sph && !o.L.sph && vPlain) ? vPlain : w;
        if (cur !== w2) return { ok: false, step: null, label: '正在更新規格…', msg: '正在更新規格，請稍候再按一次加入購物車。', sync: true };
        return { ok: true };
      }
      function validate() {
        errEl = null;
        const g = gateStatus(); gate.last = g;
        if (g.ok) return '';
        if (g.sync) { sync(); return g.msg; }
        errEl = g.el || null;
        return g.msg;
      }
      (window.pxGate = window.pxGate || { items: [] }).items.push({ pid: String(root.dataset.productId), ids: V ? V.v.map((x) => String(x.id)) : [], status: gateStatus, block: (b) => { const err = validate(); if (err) showBlock(err, b); return !!err; } });
      // 擋下加入購物車時：展開有問題的步驟、錯誤顯示在欄位旁、捲動並聚焦到第一個錯誤、按鈕抖動
      function showBlock(err, b) {
        const gs = gate.cfg && gate.last && ['lens', 'color', 'rx'].includes(gate.last.step) ? gate.last.step : null;
        if (gs) { rmsg.textContent = ''; pdInline(''); steps[gs].gm.textContent = err; }
        else if (errEl === pdIn) { rmsg.textContent = ''; pdInline(err); } else { pdInline(''); rmsg.textContent = err; }
        if (rx.reveal) rx.reveal(errEl || rmsg);
        const tgt = (errEl && errEl.closest('.pxg-in')) || errEl || rmsg;
        setTimeout(() => { tgt.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (errEl) { try { errEl.focus({ preventScroll: true }); } catch (_) {} } }, 380);
        blockBtn(b);
      }
      rx.fill = function (r, pd) {
        gate.t.rx = true;
        for (const k of ['R', 'L']) { const e = eyes[k], v = r[k]; if (!v) continue;
          e.sph.value = v.sp ? fmt(v.sp) : '0';
          e.cyl.value = v.ast ? fmt(v.ast) : ''; e.wrap.hidden = !v.ast; e.axis.disabled = !v.ast; e.axis.value = v.ast && v.axis ? String(v.axis) : ''; }
        if (pd != null && Number.isFinite(pd)) pdIn.value = String(pd); pdInline('');
        update();
      };
      box.addEventListener('change', (e) => { if (e.target.matches('[data-rx=cyl],[data-rx=sph]') || e.target === pdIn || e.target.matches('[data-rx=axis]')) sync(); });
      box.addEventListener('input', (e) => { if (e.target === pdIn || e.target.matches('[data-rx=axis]')) update(); if (e.target === pdIn && pdEr.textContent) { const v = pdIn.value.trim() === '' ? null : Number(pdIn.value); pdInline(pdErr(v)); } });
      pdIn.addEventListener('change', () => { if (pdIn.value.trim() !== '') pdInline(pdErr(Number(pdIn.value))); });
      pdIn.addEventListener('beforeinput', (e) => { if (e.data && /[^0-9.]/.test(e.data)) e.preventDefault(); });
      // 送出前檢查（擷取階段，擋在主題的加入購物車處理之前）
      document.addEventListener('submit', (e) => {
        const fm = e.target; if (!(fm instanceof HTMLFormElement) || !fm.matches('form[action*="/cart/add"]')) return;
        const pid = fm.querySelector('input[name="product-id"]') ? fm.querySelector('input[name="product-id"]').value : null;
        if (pid && pid !== root.dataset.productId) return;
        const err = validate();
        if (err) { e.preventDefault(); e.stopImmediatePropagation(); showBlock(err, fm.querySelector('button.add-to-cart-button')); }
        else { pdInline(''); const o = state(); writeProps(o, curRx() === vPlain); }
      }, true);
      // 主題的加入購物車是按鈕 click 處理（不經過 submit），所以也要在 click 擷取階段檢查
      document.addEventListener('click', (e) => {
        const t = e.target instanceof Element ? e.target : null; if (!t) return;
        const b = t.closest('button.add-to-cart-button, shopify-accelerated-checkout, shopify-buy-it-now-button'); if (!b) return;
        const err = validate();
        if (err) { e.preventDefault(); e.stopImmediatePropagation(); showBlock(err, b); }
        else { pdInline(''); const o = state(); writeProps(o, curRx() === vPlain); }
      }, true);

      // =============== 步驟式配置器（Apple 選配風格） ===============
      const OPT = data.name; // 度數
      const hostPicker = picker();
      if (!V || !hostPicker || !hostPicker.parentElement) { applyMode(); update(); return; }
      const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const names = (root.dataset.colors || '').split(','); let thumbs = []; try { thumbs = JSON.parse(root.dataset.thumbs || '[]'); } catch (_) {}
      const LENS = { '晶緻鍍膜防霧': '濾鏡分類 2・晶緻鍍膜', '強化耐磨防霧': '濾鏡分類 0・強化耐磨' };
      const optVals = (n) => V.values[V.names.indexOf(n)] || [];
      const steps = {};
      const order = ['lens', 'color', 'rx', 'eyes', 'pd'];
      function mk(key, title) {
        const s = document.createElement('section'); s.className = 'pxg-st'; s.dataset.st = key;
        s.innerHTML = `<header class="pxg-st__hd" role="button" tabindex="0" aria-expanded="false"><div class="pxg-st__t"><h3>${title}</h3><p class="pxg-st__sum" data-sum></p></div><span class="pxg-st__add" data-add></span><span class="pxg-st__chg">變更</span></header><div class="pxg-st__bd"><p class="pxg-gmsg" data-gm role="alert"></p><div class="pxg-st__in" data-in></div></div>`;
        s.hd = s.querySelector('.pxg-st__hd'); s.sumEl = s.querySelector('[data-sum]'); s.addEl = s.querySelector('[data-add]'); s.inEl = s.querySelector('[data-in]'); s.gm = s.querySelector('[data-gm]');
        steps[key] = s; return s;
      }
      const lensName = V.names.includes('鏡片') ? '鏡片' : V.names[0];
      const colName = V.names.includes('鏡框顏色') ? '鏡框顏色' : V.names[1];
      const stLens = mk('lens', '選擇鏡片'), stCol = mk('color', '選擇鏡框顏色'), stRx = mk('rx', '選擇度數類型'), stEyes = mk('eyes', '左右眼度數'), stPd = mk('pd', '瞳距 PD');
      // 卡片
      function cardHTML(kind, val, title, sub, thumb) {
        return `<button type="button" class="pxg-card${thumb ? ' pxg-card--c' : ''}" data-kind="${kind}" data-val="${esc(val)}" aria-pressed="false">${thumb ? `<img src="${esc(thumb)}" alt="" width="180" height="112" loading="lazy">` : ''}<span class="pxg-card__t"><b>${title}</b>${sub ? `<small>${sub}</small>` : ''}</span><em class="pxg-card__add" data-add></em></button>`;
      }
      stLens.inEl.innerHTML = `<div class="pxg-cards">${optVals(lensName).map((v) => cardHTML('lens', v, esc(v), LENS[v] || '')).join('')}</div>`;
      stCol.inEl.innerHTML = `<div class="pxg-cards pxg-cards--c">${optVals(colName).map((v) => { const i = names.findIndex((n) => v.endsWith(n)); const code = v.replace(names[i] || '', '').trim(); return cardHTML('color', v, esc(names[i] || v), esc(code), thumbs[i] || ''); }).join('')}</div>`;
      stRx.inEl.innerHTML = `<div class="pxg-cards">${cardHTML('rx', 'plain', '平光（無度數）', '不配度數，不需填 PD')}${cardHTML('rx', 'my', '近視（可加散光）', '度數 -1.0D～-8.0D；有散光可在下一步加選')}</div><a class="pxg-jump" href="#${calc.id}" data-jump>不確定怎麼選？用驗光單換算</a>`;
      // 左右眼
      const eyesGrid = box.querySelector('.pxg-calc__eyes');
      const surNote = document.createElement('p'); surNote.className = 'pxg-surnote'; surNote.hidden = true; surNote.setAttribute('role', 'status');
      stEyes.inEl.append(eyesGrid, surNote, rmsg);
      const nextEyes = document.createElement('button'); nextEyes.type = 'button'; nextEyes.className = 'pxg-btn pxg-btn--next'; nextEyes.textContent = '下一步：瞳距 PD'; stEyes.inEl.append(nextEyes);
      stPd.inEl.append(pdBox);
      const doneBtn = document.createElement('button'); doneBtn.type = 'button'; doneBtn.className = 'pxg-btn pxg-btn--next'; doneBtn.textContent = '完成'; stPd.inEl.append(doneBtn);
      const note = box.querySelector('.pxg-note'); if (note) stPd.inEl.append(note);
      // 合計
      const total = document.createElement('div'); total.className = 'pxg-total'; total.setAttribute('aria-live', 'polite');
      total.innerHTML = '<div class="pxg-total__hd"><span class="pxg-total__k">目前配置</span><span class="pxg-total__cfg" data-cfg></span></div><ul class="pxg-total__ls" data-ls></ul><div class="pxg-total__sum"><span>合計</span><b data-sum>—</b></div>';
      // 重組 box
      box.textContent = '';
      box.classList.add('pxg-cfg'); gate.cfg = true;
      order.forEach((k) => box.append(steps[k]));
      box.append(total, props);
      hostPicker.insertAdjacentElement('afterend', box);
      document.body.classList.add('pxg-cfg-on');
      if (!hasAst) eyes.R.cyl.closest('label').hidden = eyes.L.cyl.closest('label').hidden = true;

      let openKey = 'lens';
      function setOpen(k) {
        openKey = k;
        order.forEach((key) => { const s = steps[key]; const on = key === k && !s.hidden; s.classList.toggle('is-open', on); s.hd.setAttribute('aria-expanded', on ? 'true' : 'false'); s.querySelector('.pxg-st__bd').toggleAttribute('inert', !on); });
      }
      function scrollToStep(k) {
        const s = steps[k]; if (!s) return;
        setTimeout(() => { const r = s.getBoundingClientRect(); if (r.top < 70 || r.top > innerHeight * 0.55) s.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 360);
      }
      function openStep(k, scroll) { setOpen(k); if (scroll) scrollToStep(k); }
      rx.reveal = (el) => { const s = el && el.closest ? el.closest('.pxg-st') : null; if (s && s.dataset.st) setOpen(s.dataset.st); };
      order.forEach((k) => { const s = steps[k]; const go = () => { if (!s.classList.contains('is-open')) openStep(k, true); }; s.hd.addEventListener('click', go); s.hd.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } }); });
      function nextOf(k) { const i = order.indexOf(k); for (let j = i + 1; j < order.length; j++) if (!steps[order[j]].hidden) return order[j]; return null; }
      box.addEventListener('click', async (e) => {
        const c = e.target.closest ? e.target.closest('.pxg-card') : null;
        if (c) {
          const kind = c.dataset.kind, val = c.dataset.val;
          gate.t[kind] = true; steps[kind].gm.textContent = '';
          if (kind === 'lens') await setOption(lensName, val);
          else if (kind === 'color') await setOption(colName, val);
          else if (kind === 'rx') await setOption(OPT, val === 'plain' ? vPlain : (vMy || vAst));
          applyMode(); update();
          const nk = kind === 'lens' ? 'color' : kind === 'color' ? 'rx' : (val === 'plain' ? null : 'eyes');
          setTimeout(() => { setOpen(nk); if (nk) scrollToStep(nk); }, 260);
          return;
        }
        if (e.target === nextEyes) { errEl = null; const m = eyesErr(); if (m) { rmsg.textContent = m; if (errEl) errEl.focus({ preventScroll: true }); blockBtn(nextEyes); } else { rmsg.textContent = ''; setOpen('pd'); scrollToStep('pd'); } return; }
        if (e.target === doneBtn) { const m = pdErr(state().pd); if (m) { pdInline(m); pdIn.focus({ preventScroll: true }); blockBtn(doneBtn); } else { pdInline(''); setOpen(null); setTimeout(() => total.scrollIntoView({ behavior: 'smooth', block: 'center' }), 380); } return; }
        const j = e.target.closest ? e.target.closest('[data-jump]') : null;
        if (j) { e.preventDefault(); calc.scrollIntoView({ behavior: 'smooth', block: 'start' }); try { calc.focus({ preventScroll: true }); } catch (_) {} }
      });
      // 渲染（依原生選項狀態）
      function render() {
        const s = selection(); const c = s[OPT]; const plain = c === vPlain; const o = state();
        const price = priceOf(s);
        // 卡片選取狀態與加價
        const base = (name, val) => ({ ...s, [name]: val });
        const lensMin = Math.min(...optVals(lensName).map((v) => priceOf(base(lensName, v)) ?? Infinity));
        stLens.inEl.querySelectorAll('.pxg-card').forEach((b) => { const v = b.dataset.val; const on = s[lensName] === v; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); const p = priceOf(base(lensName, v)); const d = p != null ? p - lensMin : 0; b.querySelector('[data-add]').textContent = d > 0 ? '+' + NT(d) : ''; });
        stCol.inEl.querySelectorAll('.pxg-card').forEach((b) => { const on = s[colName] === b.dataset.val; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        const pPlain = vPlain ? priceOf(base(OPT, vPlain)) : null, pMy = vMy ? priceOf(base(OPT, vMy)) : null, pAst = vAst ? priceOf(base(OPT, vAst)) : null;
        stRx.inEl.querySelectorAll('.pxg-card').forEach((b) => { const on = (b.dataset.val === 'plain') === plain; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); const add = b.dataset.val === 'plain' ? 0 : (pMy != null && pPlain != null ? pMy - pPlain : 0); const sub = b.querySelector('small'); b.querySelector('[data-add]').textContent = add > 0 ? '+' + NT(add) : ''; if (b.dataset.val === 'my' && sub) sub.textContent = `度數 -1.0D～-8.0D${hasAst && pAst != null && pMy != null && pAst > pMy ? `；加選散光再 +${NT(pAst - pMy)}` : (hasAst ? '；可加選散光' : '')}`; });
        // 步驟顯示
        stEyes.hidden = stPd.hidden = plain;
        if (plain && (openKey === 'eyes' || openKey === 'pd')) setOpen(null);
        // 摘要
        { const cv = s[colName] || '', cn = cv.replace(/^\S+\s/, ''); stLens.sumEl.textContent = s[lensName] || ''; stCol.sumEl.textContent = cn ? `${cn}（${cv.split(' ')[0]}）` : cv; }
        stRx.sumEl.textContent = plain ? '平光（無度數）' : (o.anyCyl ? '近視＋散光' : '近視');
        if (!gate.t.lens) stLens.sumEl.textContent = '尚未選擇'; if (!gate.t.color) stCol.sumEl.textContent = '尚未選擇'; if (!gate.t.rx) stRx.sumEl.textContent = '尚未選擇';
        const done = o.R.sphSet && o.L.sphSet && !(o.R.cyl && !axisOk(o.R.axis)) && !(o.L.cyl && !axisOk(o.L.axis));
        const el = (n, e) => `${n} ${e.sph ? fmt(e.sph) : '平光'}${e.cyl ? `／${e.cyl}／軸度 ${e.axis || '—'}` : ''}`;
        stEyes.sumEl.textContent = (o.R.sphSet && o.L.sphSet) ? `${el('右眼', o.R)}；${el('左眼', o.L)}` : '尚未選擇';
        stPd.sumEl.textContent = o.pd != null && !pdErr(o.pd) ? `${o.pd}mm` : '尚未填寫';
        stLens.addEl.textContent = price != null && price - lensMin > 0 ? '+' + NT(price - lensMin) : '';
        stRx.addEl.textContent = !plain && pMy != null && pPlain != null ? '+' + NT((o.anyCyl && pAst != null ? pAst : pMy) - pPlain) : '';
        stRx.addEl.hidden = stLens.addEl.hidden = false;
        // 散光加價提示
        const sur = hasAst && pAst != null && pMy != null ? pAst - pMy : 0;
        for (const k of ['R', 'L']) { if (eyes[k].sur) eyes[k].sur.textContent = sur > 0 ? `選散光加 ${NT(sur)}` : ''; }
        surNote.hidden = !(o.anyCyl && sur > 0 && !plain); surNote.textContent = `已選散光：規格自動切換為「近視＋散光」，價格 +${NT(sur)}（已計入合計）。`;
        // 合計
        const cfgTxt = [s[lensName], (s[colName] || '').replace(/^\S+\s/, ''), plain ? '平光' : (o.anyCyl ? '近視＋散光' : '近視')].filter(Boolean).join('・');
        total.querySelector('[data-cfg]').textContent = cfgTxt;
        const ls = []; const baseP = pPlain != null ? pPlain : price;
        if (baseP != null) ls.push(`<li><span>鏡框與鏡片${plain ? '（平光）' : '（平光基本價）'}</span><b>${NT(baseP)}</b></li>`);
        if (!plain && pMy != null && pPlain != null && pMy > pPlain) ls.push(`<li><span>近視度數</span><b>+${NT(pMy - pPlain)}</b></li>`);
        if (!plain && o.anyCyl && sur > 0) ls.push(`<li><span>散光加價</span><b>+${NT(sur)}</b></li>`);
        total.querySelector('[data-ls]').innerHTML = ls.join('');
        total.querySelector('[data-sum]').textContent = price != null ? NT(price) : '—';
        total.dataset.price = price != null ? String(price) : '';
        const doneAll = gateStatus().ok;
        total.classList.toggle('is-ready', !!doneAll);
        for (const k of order) { const st = steps[k]; st.classList.toggle('is-set', !!st.sumEl.textContent && st.sumEl.textContent !== '尚未選擇' && st.sumEl.textContent !== '尚未填寫'); }
      }
      rx.render = render;
      setOpen('lens');
      // 初始狀態：網址帶入「近視＋散光」但左右眼尚未選散光 → 視為近視
      (async () => { applyMode(); if (curRx() === vAst && !state().anyCyl && vMy) { await setOption(OPT, vMy); applyMode(); } update(); })();
      // 監聽原生選項變化（含驗光單換算、網址變體）
      let lastKey = '';
      setInterval(() => { const k = JSON.stringify(selection()); if (k !== lastKey) { lastKey = k; applyMode(); update(); } }, 300);
      document.addEventListener('change', (e) => { if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(() => { applyMode(); update(); }, 60); });
    })();
    // ---- 顏色選項下方：「不確定怎麼選？用驗光單換算」連結 ----
    (function () {
      const target = calc;
      function inject() {
        const vp = picker(); if (!vp) return;
        const r = vp.querySelector('input[data-option-name="鏡框顏色"]');
        const fs = r ? r.closest('fieldset') : null; if (!fs) return;
        if (fs.nextElementSibling && fs.nextElementSibling.classList.contains('pxg-jump')) return;
        vp.querySelectorAll('.pxg-jump').forEach((x) => x.remove());
        const a = document.createElement('a'); a.className = 'pxg-jump'; a.href = '#' + target.id; a.textContent = '不確定怎麼選？用驗光單換算';
        a.addEventListener('click', (e) => { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); try { target.focus({ preventScroll: true }); } catch (_) {} history.replaceState(null, '', '#' + target.id); });
        fs.insertAdjacentElement('afterend', a);
      }
      inject();
      const vp0 = picker(); if (vp0) new MutationObserver(() => inject()).observe(vp0, { childList: true, subtree: true });
      setInterval(inject, 1000);
    })();
    // ---- 選顏色 → 切換故事區塊的主圖 ----
    (function () {
      const hero = root.querySelector('[data-pxg-hero]'); if (!hero) return;
      let srcs = []; try { srcs = JSON.parse(root.dataset.heroSrcs || '[]'); } catch (_) {}
      const names = (root.dataset.colors || '').split(',');
      function apply() {
        const vp = picker(); if (!vp) return;
        const r = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.checked && i.dataset.optionName === '鏡框顏色');
        let val = r ? r.value : null;
        if (!val) { const sel = [...vp.querySelectorAll('select')].find((x) => x.name === 'options[鏡框顏色]'); val = sel ? sel.value : null; }
        if (!val) return;
        const i = names.findIndex((n) => val.endsWith(n));
        if (i < 0 || !srcs[i]) return;
        if (hero.getAttribute('src') !== srcs[i]) hero.src = srcs[i];
        root.querySelectorAll('.pxg-cols li').forEach((li) => li.classList.toggle('is-on', li.dataset.color === names[i]));
      }
      document.addEventListener('change', () => setTimeout(apply, 50));
      let lf = null; setInterval(() => { const id = formId(); if (id !== lf) { lf = id; apply(); } }, 500);
      apply();
    })();
    calc.addEventListener('input', run);
    btn.addEventListener('click', async () => {
      if (!pick) return;
      btn.disabled = true; const t = btn.textContent; btn.textContent = '套用中…';
      if (last && rx.fill) rx.fill(last.r, last.pd);
      const ok = await setOption(data.name, pick);
      const id = formId();
      if (ok && id) { const u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); }
      btn.textContent = ok ? '已套用 ✓' : '請在上方選項手動選擇';
      const vp = rx.box || picker(); if (vp) vp.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { btn.textContent = t; run(); }, 2500);
    });
    run();
  }
  const boot = () => document.querySelectorAll('[data-pxg]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["px-product-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const EPS = 1e-9;
  /** Normalise a 度 / diopter entry to a positive diopter magnitude. */
  function toDiopter(raw) {
    if (raw == null) return null;
    let s = String(raw).trim().replace(/[度°dD\s]/g, '').replace(/[－−]/g, '-').replace(/＋/g, '+').replace(/，/g, '.');
    if (s === '' || s === '-' || s === '+') return null;
    const n = Number(s);
    if (!Number.isFinite(n)) return NaN;
    const a = Math.abs(n);
    // Taiwanese 度: 450 = 4.50D, 75 = 0.75D. Values with a decimal point or below 20 are read as D.
    if (!s.includes('.') && a >= 20) return a / 100;
    return a;
  }
  /** Parse "-4.5D 近視" / "+2.0D 遠視" / "0度（平光）" into { kind, mag }. */
  function parseOpt(label) {
    const m = String(label).match(/([+-]?\d+(?:\.\d+)?)\s*D/);
    if (!m) return { label, kind: '0', mag: 0 };
    return { label, kind: label.includes('遠視') ? 'H' : 'M', mag: Math.abs(Number(m[1])) };
  }
  const fmt = (d) => (Math.round(d * 1000) / 1000).toString();
  const fmt2 = (d) => d.toFixed(2);

  function init(root) {
    const calc = root.querySelector('[data-pxs-calc]');
    if (!calc || calc.dataset.ready) return;
    calc.dataset.ready = '1';
    const data = JSON.parse(calc.querySelector('[data-pxs-options]').textContent);
    const opts = { L: (data.left || []).map(parseOpt), R: (data.right || []).map(parseOpt) };
    const names = { L: data.leftName, R: data.rightName };
    const msg = calc.querySelector('[data-msg]');
    const btn = calc.querySelector('[data-apply]');
    let picks = { L: null, R: null };

    function suggest(eye, kind, d) {
      const list = opts[eye].filter((o) => o.kind === kind).sort((a, b) => a.mag - b.mag);
      const zero = opts[eye].find((o) => o.kind === '0');
      if (!list.length) return { opt: null, note: '此類型無可選度數' };
      const min = list[0].mag, max = list[list.length - 1].mag;
      if (d < min - EPS) return { opt: zero, note: `低於 ${fmt2(min)}D，建議 0 度（平光），或先諮詢驗光師` };
      if (d > max + EPS) return { opt: list[list.length - 1], note: '超過可配範圍，請先諮詢驗光師' };
      let best = list[0];
      for (const o of list) if (o.mag <= d + EPS) best = o;
      return { opt: best, note: '' };
    }

    function run() {
      picks = { L: null, R: null };
      const state = {};
      for (const fs of calc.querySelectorAll('.pxs-eye')) {
        const eye = fs.dataset.eye;
        const kind = fs.querySelector('input[type=radio]:checked').value;
        const sph = toDiopter(fs.querySelector('[data-f=sph]').value);
        const cyl = toDiopter(fs.querySelector('[data-f=cyl]').value) ?? 0;
        const out = fs.querySelector('[data-out]');
        state[eye] = { kind, entered: sph !== null };
        if (sph === null) { out.innerHTML = '請輸入球面度數'; continue; }
        if (Number.isNaN(sph) || Number.isNaN(cyl)) { out.innerHTML = '<em>請輸入數字，例如 450 或 -4.50</em>'; continue; }
        const d = sph + cyl / 2;
        const s = suggest(eye, kind, d);
        picks[eye] = s.opt;
        state[eye].opt = s.opt;
        const label = kind === 'H' ? '遠視' : '近視';
        out.innerHTML =
          `${label} ${fmt2(sph)} + 散光 ${fmt2(cyl)} ÷ 2 = <span data-computed>${fmt(d)}</span>D（${fmt(d * 100)} 度）` +
          `${kind === 'H' ? '・依上述公式估算' : ''}` +
          `<b data-suggest>${s.opt ? s.opt.label : '—'}</b>` +
          (s.note ? `<em>${s.note}</em>` : '選擇最接近且較低的度數') +
          (cyl >= 1.75 - EPS ? `<em style="display:block;margin-top:6px">散光 -${fmt2(cyl)}D 偏高：換算後殘留的散光明顯，可能重影、變形、夜間模糊，不建議長期使用。請先洽詢客服或驗光師再下單。</em>` : '');
      }
      // Hyperopia must be chosen for both eyes and cannot be combined with 近視 or 0 度.
      let err = '';
      const kinds = [picks.L, picks.R].map((o) => (o ? o.kind : null));
      const anyH = kinds.includes('H') || (state.L?.kind === 'H' && state.L.entered) || (state.R?.kind === 'H' && state.R.entered);
      if (anyH && !(kinds[0] === 'H' && kinds[1] === 'H')) err = '遠視度數需兩眼皆選遠視，不提供與近視或 0 度混搭。';
      msg.textContent = err;
      btn.disabled = !!err || !picks.L || !picks.R;
    }

    function picker() {
      const pid = root.dataset.productId;
      return document.querySelector(`variant-picker[data-product-id="${pid}"][data-template-product-match="true"]`) ||
        document.querySelector(`variant-picker[data-product-id="${pid}"]`);
    }
    function settle(target, timeout = 4000, first = 1200) {
      return new Promise((resolve) => {
        let t; const done = () => { obs.disconnect(); clearTimeout(t); clearTimeout(hard); resolve(); };
        const obs = new MutationObserver(() => { clearTimeout(t); t = setTimeout(done, 250); });
        obs.observe(target, { subtree: true, childList: true, attributes: true });
        t = setTimeout(done, first);
        const hard = setTimeout(done, timeout);
      });
    }
    function selected(vp) {
      return new Promise((resolve) => {
        let to;
        const h = (e) => { vp.removeEventListener('shopify:product:select', h); clearTimeout(to); resolve(e); };
        vp.addEventListener('shopify:product:select', h);
        to = setTimeout(() => { vp.removeEventListener('shopify:product:select', h); resolve(null); }, 1500);
      });
    }
    function formId() {
      const pid = root.dataset.productId;
      const f = document.querySelector(`form[data-product-id="${pid}"] input[name="id"]`) ||
        document.querySelector('[id^="ProductInformation"] form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return f ? f.value : null;
    }
    async function commit(vp, el, fire) {
      const before = formId();
      const evP = selected(vp);
      fire();
      const e = await evP;
      const pr = e && (e.promise || (e.detail && e.detail.promise));
      const t0 = Date.now();
      if (pr && typeof pr.then === 'function') {
        await Promise.race([pr.catch(() => {}), new Promise((r) => setTimeout(r, 6000))]);
      }
      // wait until the buy form carries the new variant (or 5 s), then for the DOM to go quiet
      while (formId() === before && Date.now() - t0 < 5000) await new Promise((r) => setTimeout(r, 100));
      await settle(vp.parentElement || vp, 3000, 300);
    }
    async function setOption(name, value) {
      const vp = picker();
      if (!vp) return false;
      const radio = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === name && i.value === value);
      if (radio) {
        if (radio.checked) return true;
        await commit(vp, radio, () => radio.click());
        return true;
      }
      const sel = [...vp.querySelectorAll('select')].find((s) => s.name === `options[${name}]`);
      if (!sel) return false;
      if (sel.value === value) return true;
      await commit(vp, sel, () => { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); });
      return true;
    }

    calc.addEventListener('input', run);
    calc.addEventListener('change', run);
    btn.addEventListener('click', async () => {
      if (!picks.L || !picks.R) return;
      btn.disabled = true; const txt = btn.textContent; btn.textContent = '套用中…';
      const ok1 = await setOption(names.L, picks.L.label);
      const ok2 = await setOption(names.R, picks.R.label);
      const id = formId();
      if (id && ok1 && ok2) { const u = new URL(location.href); if (u.searchParams.get('variant') !== id) { u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); } }
      btn.textContent = ok1 && ok2 ? '已套用 ✓' : '請在上方選項手動選擇';
      document.dispatchEvent(new CustomEvent('pxs:applied'));
      const vp = picker();
      if (vp && !document.body.classList.contains('pxz-cfg-on')) vp.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(() => { btn.textContent = txt; run(); }, 2500);
    });
    run();
  }
  document.addEventListener('input', (e) => {
    const r = e.target;
    if (r instanceof HTMLInputElement && r.classList.contains('pxs-fv__range')) r.closest('.pxs-fv').style.setProperty('--pos', r.value + '%');
  });
  const boot = () => document.querySelectorAll('[data-pxs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  /* hero follows the selected frame colour: native 3/4 photo for its own colour, else that colour's gallery photo */
  (() => {
    let lastKey = null, orig = null;
    const sync = () => {
      const hero = document.querySelector('[data-pxs-hero]');
      const g = document.querySelector('media-gallery slideshow-slide[aria-hidden="false"] img');
      if (!hero || !g) return;
      if (!orig) orig = { src: hero.getAttribute('src'), srcset: hero.getAttribute('srcset') };
      const sel = [...document.querySelectorAll('variant-picker input[type=radio]:checked')].find((r) => /色/.test(r.dataset.optionName || r.name || ''));
      const native = sel && sel.value.trim() === hero.dataset.nativeColor;
      const base = (g.getAttribute('src') || '').replace(/&?width=\d+/, '');
      const key = native ? 'native' : base;
      if (!sel || !base || key === lastKey) return;
      lastKey = key;
      if (native) { hero.src = orig.src; hero.srcset = orig.srcset; return; }
      const u = (w) => base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      hero.removeAttribute('srcset');
      hero.src = u(1600);
      hero.srcset = u(800) + ' 800w, ' + u(1200) + ' 1200w, ' + u(1600) + ' 1600w';
    };
    document.addEventListener('change', () => setTimeout(sync, 400));
    setInterval(sync, 600);
  })();

/* ===== ZH-700 步驟式配置器：顏色 → 度數類型 → 左右眼度數 → 瞳距 PD；原生選項隱藏但仍是唯一的變體來源 ===== */
(() => {
  const PD_LO = 58, PD_HI = 70;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const NT = (c) => 'NT$' + Math.round(c / 100).toLocaleString('en-US');
  const DOT = { '紅': '#C8352B', '綠': '#1E8C7A', '灰': '#8E9196' };
  const N = { c: '鏡框顏色', L: '左眼度數', R: '右眼度數' };
  const kind = (v) => (!v ? null : v.startsWith('0') ? '0' : v.includes('遠視') ? 'H' : 'M');
  const short = (v) => (kind(v) === '0' ? '平光' : String(v).replace(/\s*(近視|遠視)\s*$/, ''));
  const cname = (v) => (String(v).length === 1 ? v + '色' : v);
  const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cfg(root) {
    if (root.dataset.pxzReady) return true;
    const dEl = root.querySelector('[data-pxz-data]');
    const pid = root.dataset.productId;
    const picker = () => document.querySelector(`variant-picker[data-product-id="${pid}"][data-template-product-match="true"]`) || document.querySelector(`variant-picker[data-product-id="${pid}"]`);
    const host = picker();
    if (!dEl || !host || !host.parentElement) return false;
    root.dataset.pxzReady = '1';
    const D = JSON.parse(dEl.textContent);
    const ZERO = { L: D.left.find((v) => kind(v) === '0'), R: D.right.find((v) => kind(v) === '0') };
    const LIST = { L: D.left, R: D.right };
    const diff = Math.max(0, D.priceRx - D.pricePlain);

    // ---------- 原生選項（唯一的變體來源） ----------
    function nativeVal(name) {
      const vp = picker(); if (!vp) return null;
      const r = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === name && i.checked);
      if (r) return r.value;
      const s = [...vp.querySelectorAll('select')].find((x) => x.name === `options[${name}]`);
      return s ? s.value : null;
    }
    function formId() {
      const f = document.querySelector(`form[data-product-id="${pid}"] input[name="id"]`) || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return f ? f.value : null;
    }
    function mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]'); }
    async function setOption(name, value) {
      const vp = picker(); if (!vp) return false;
      const radio = [...vp.querySelectorAll('input[type=radio]')].find((i) => i.dataset.optionName === name && i.value === value);
      if (radio) {
        if (radio.checked) return true;
        const before = formId(); radio.click();
        const t0 = Date.now();
        while (Date.now() - t0 < 6000) { await sleep(80); if (formId() !== before && nativeVal(name) === value) break; }
        await sleep(150);
        return nativeVal(name) === value;
      }
      const sel = [...vp.querySelectorAll('select')].find((s) => s.name === `options[${name}]`);
      if (!sel) return false; if (sel.value === value) return true;
      const before = formId(); sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true }));
      const t0 = Date.now(); while (formId() === before && Date.now() - t0 < 5000) await sleep(100);
      await sleep(150); return true;
    }
    let busy = 0, chain = Promise.resolve(), lastSig = '';
    const sig = () => [nativeVal(N.L), nativeVal(N.R)].join('|');
    const run = (fn) => { busy++; chain = chain.then(fn).catch(() => {}).then(() => { busy--; if (!busy) lastSig = sig(); render(); }); return chain; };

    // ---------- 狀態 ----------
    let mode = 'plain'; // plain | my | hy
    let openKey = 'color';
    const steps = {}; const order = ['color', 'rx', 'eyes', 'pd'];
    function mk(key, t1, t2) {
      const s = document.createElement('section'); s.className = 'pxz-st'; s.dataset.st = key;
      s.innerHTML = `<h3 class="pxz-st__h"><button type="button" class="pxz-st__hd" id="pxz-h-${key}-${root.id}" aria-expanded="false" aria-controls="pxz-p-${key}-${root.id}"><span class="pxz-st__tx"><span class="pxz-st__t"><span class="pxz-t1">${t1}。</span><span class="pxz-t2">${t2}</span></span><span class="pxz-st__sum" data-sum></span></span><span class="pxz-st__add" data-add></span><span class="pxz-st__chg" aria-hidden="true">變更</span></button></h3><div class="pxz-st__bd" id="pxz-p-${key}-${root.id}" role="region" aria-labelledby="pxz-h-${key}-${root.id}"><p class="pxz-gmsg" data-gm role="alert"></p><div class="pxz-st__in" data-in></div></div>`;
      s.hd = s.querySelector('.pxz-st__hd'); s.sumEl = s.querySelector('[data-sum]'); s.addEl = s.querySelector('[data-add]'); s.inEl = s.querySelector('[data-in]'); s.gm = s.querySelector('[data-gm]'); s.bd = s.querySelector('.pxz-st__bd');
      steps[key] = s; return s;
    }
    mk('color', '選擇鏡框顏色', '選一個你喜歡的。');
    mk('rx', '選擇度數類型', '平光、近視或遠視。');
    mk('eyes', '左右眼度數', '兩眼可分別選擇。');
    mk('pd', '瞳距 PD', '依驗光單填寫。');

    const card = (kindName, val, title, sub, thumb, add, dot) => `<button type="button" role="radio" aria-checked="false" tabindex="-1" class="pxz-card${thumb ? ' pxz-card--c' : ''}" data-kind="${kindName}" data-val="${esc(val)}">${thumb ? `<img src="${esc(thumb)}" alt="" width="240" height="240" loading="lazy">` : ''}<span class="pxz-card__t"><b>${dot ? `<i class="pxz-dot" style="background:${dot}"></i>` : ''}${title}</b>${sub ? `<small>${sub}</small>` : ''}</span><em class="pxz-card__add" data-add>${add || ''}</em></button>`;
    steps.color.inEl.innerHTML = `<div class="pxz-cards pxz-cards--c" role="radiogroup" aria-labelledby="pxz-h-color-${root.id}">${D.colors.map((c) => card('color', c.v, esc(cname(c.v)), '', c.img, '', DOT[c.v] || '')).join('')}</div>`;
    steps.rx.inEl.innerHTML = `<div class="pxz-cards" role="radiogroup" aria-labelledby="pxz-h-rx-${root.id}">${card('rx', 'plain', '平光', '兩眼都是 0 度，不需要填 PD', '', '')}${card('rx', 'my', '近視', '度數 -1.5D～-10.0D，左右眼可分別選', '', '')}${card('rx', 'hy', '遠視', '度數 +1.5D～+4.0D，兩眼皆須選遠視', '', '')}</div><a class="pxz-jump" href="#" data-jump>不確定怎麼選？用驗光單換算</a>`;
    const eyeHTML = (e, name) => `<fieldset class="pxz-eye" data-eye="${e}"><legend>${name}</legend><label class="pxz-fld"><span>${name}度數</span><select class="pxz-sel" data-sel="${e}" autocomplete="off" aria-describedby="pxz-hint-${root.id}"></select></label></fieldset>`;
    steps.eyes.inEl.innerHTML = `<div class="pxz-eyes">${eyeHTML('R', '右眼')}${eyeHTML('L', '左眼')}</div><p class="pxz-hint" id="pxz-hint-${root.id}" data-hint></p><p class="pxz-note" data-fnote hidden role="status"></p><span class="pxz-err" data-eerr role="alert"></span><button type="button" class="pxz-btn" data-next-eyes>下一步：瞳距 PD</button>`;
    steps.pd.inEl.innerHTML = `<label class="pxz-fld pxz-pdbox"><span>瞳距 PD（mm），此款適用 ${PD_LO}–${PD_HI}</span><input class="pxz-pd" type="number" inputmode="decimal" min="${PD_LO}" max="${PD_HI}" step="any" placeholder="例：64" autocomplete="off" aria-describedby="pxz-pderr-${root.id}" data-pd></label><span class="pxz-err" id="pxz-pderr-${root.id}" data-pderr role="alert"></span><p class="pxz-hint">加入購物車時，會附上您填的 PD。建議僅供參考，請以驗光單為準。</p><button type="button" class="pxz-btn" data-done>完成</button>`;

    const sel = { R: steps.eyes.inEl.querySelector('[data-sel=R]'), L: steps.eyes.inEl.querySelector('[data-sel=L]') };
    const eerr = steps.eyes.inEl.querySelector('[data-eerr]'), hint = steps.eyes.inEl.querySelector('[data-hint]'), fnote = steps.eyes.inEl.querySelector('[data-fnote]');
    const nextEyes = steps.eyes.inEl.querySelector('[data-next-eyes]');
    const pdIn = steps.pd.inEl.querySelector('[data-pd]'), pdEr = steps.pd.inEl.querySelector('[data-pderr]'), doneBtn = steps.pd.inEl.querySelector('[data-done]');
    const props = document.createElement('div'); props.hidden = true;
    const total = document.createElement('div'); total.className = 'pxz-total'; total.setAttribute('aria-live', 'polite');
    total.innerHTML = '<span class="pxz-total__k">目前配置</span><span class="pxz-total__cfg" data-cfg></span><span class="pxz-total__eye" data-eye></span><ul class="pxz-total__ls" data-ls></ul><div class="pxz-total__sum"><span>合計</span><b data-sum>—</b></div>';
    const box = document.createElement('div'); box.className = 'pxz-cfg'; box.setAttribute('role', 'group'); box.setAttribute('aria-label', 'ZH-700 訂購設定');
    order.forEach((k) => box.append(steps[k]));
    box.append(total, props);
    host.insertAdjacentElement('afterend', box);
    document.body.classList.add('pxz-cfg-on');

    function fillSelects() {
      for (const e of ['R', 'L']) {
        let h = '<option value="">請選擇</option>';
        if (mode === 'my') h += `<option value="${esc(ZERO[e])}">平光（0）</option><optgroup label="近視">${LIST[e].filter((v) => kind(v) === 'M').map((v) => `<option value="${esc(v)}">${esc(short(v))}</option>`).join('')}</optgroup>`;
        else if (mode === 'hy') h += `<optgroup label="遠視">${LIST[e].filter((v) => kind(v) === 'H').map((v) => `<option value="${esc(v)}">${esc(short(v))}</option>`).join('')}</optgroup>`;
        sel[e].innerHTML = h;
      }
      hint.textContent = mode === 'hy'
        ? '遠視度數需兩眼皆選遠視，不可與近視或平光混搭。'
        : '近視 -1.5D～-7.0D 每 0.5D 一階，-7.0D 之後每 1.0D 一階，最高 -10.0D。任一眼有度數即為度數版' + (diff > 0 ? `（+${NT(diff)}）` : '') + '。';
    }
    const eyesVal = () => ({ R: sel.R.value, L: sel.L.value });
    function setErr(el, msg) { el.textContent = msg || ''; }
    function markInvalid(el, bad) { if (el) el.setAttribute('aria-invalid', bad ? 'true' : 'false'); }

    // ---------- PD ----------
    function pdVal() { const t = pdIn.value.trim(); return t === '' ? null : Number(t); }
    function pdErr(v) {
      if (v === null) return '請填瞳距 PD（mm），例如 64。';
      if (!Number.isFinite(v)) return 'PD 請填數字（mm），例如 64。';
      if (v < PD_LO || v > PD_HI) return `ZH-700 適用瞳距 PD ${PD_LO}–${PD_HI}mm（SABLE 官網標示），您填的是 ${v}mm。請對照驗光單上的 PD 值，例如 64。`;
      return '';
    }
    function pdInline(m) { setErr(pdEr, m); markInvalid(pdIn, !!m); }

    // ---------- 步驟開合 ----------
    function setOpen(k) {
      openKey = k;
      order.forEach((key) => { const s = steps[key]; const on = key === k && !s.hidden; s.classList.toggle('is-open', on); s.hd.setAttribute('aria-expanded', on ? 'true' : 'false'); s.bd.toggleAttribute('inert', !on); });
    }
    function scrollToStep(k) {
      const s = steps[k]; if (!s) return;
      setTimeout(() => { const r = s.getBoundingClientRect(); if (r.top < 70 || r.top > innerHeight * 0.55) s.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }); }, 360);
    }
    function nextOf(k) { const i = order.indexOf(k); for (let j = i + 1; j < order.length; j++) if (!steps[order[j]].hidden) return order[j]; return null; }
    function advance(k, viaKey) {
      setTimeout(() => {
        setOpen(k);
        if (k) { scrollToStep(k); if (viaKey) { try { steps[k].hd.focus({ preventScroll: true }); } catch (_) {} } }
        else setTimeout(() => total.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' }), 380);
      }, 240);
    }
    order.forEach((k) => { const s = steps[k]; s.hd.addEventListener('click', () => { if (!s.classList.contains('is-open')) { setOpen(k); scrollToStep(k); } }); });

    // ---------- 行為 ----------
    async function chooseColor(val) { await run(() => setOption(N.c, val)); }
    async function chooseMode(m) {
      if (m === mode) return;
      const prev = mode; mode = m;
      fillSelects(); sel.R.value = ''; sel.L.value = ''; setErr(eerr, ''); markInvalid(sel.R, 0); markInvalid(sel.L, 0);
      if (m !== 'plain') { /* 保留 PD 輸入 */ } else { pdIn.value = ''; pdInline(''); }
      render();
      await run(async () => {
        if (m === 'plain' || (m === 'my' && prev === 'hy')) { for (const e of ['L', 'R']) await setOption(N[e], ZERO[e]); }
      });
    }
    async function commitEyes() {
      await run(async () => {
        const v = eyesVal();
        if (mode === 'my') { for (const e of ['R', 'L']) await setOption(N[e], v[e] || ZERO[e]); }
        else if (mode === 'hy' && v.R && v.L) { for (const e of ['L', 'R']) await setOption(N[e], v[e]); }
      });
    }
    function adoptFromNative() {
      const L = nativeVal(N.L), R = nativeVal(N.R); if (!L || !R) return;
      const m = (kind(L) === 'H' || kind(R) === 'H') ? 'hy' : (kind(L) === '0' && kind(R) === '0' ? 'plain' : 'my');
      if (m !== mode) { mode = m; fillSelects(); }
      if (m === 'plain') { sel.R.value = ''; sel.L.value = ''; }
      else { sel.R.value = R; sel.L.value = L; }
    }

    // ---- 完成選配閘門：鏡框顏色、度數類型要親自選過；度數版要選左右眼度數並填 PD ----
    const GT = { color: true, rx: true };
    const GLBL = { color: '請先選擇鏡框顏色', rx: '請先選擇度數類型' };
    function gateStatus() {
      for (const k of ['color', 'rx']) if (!GT[k]) return { ok: false, step: k, label: GLBL[k], m: GLBL[k] + '，再加入購物車。', el: steps[k].hd };
      const upd = (m) => ({ ok: false, step: null, label: '正在更新規格…', m, upd: true });
      if (mode === 'plain') {
        if (kind(nativeVal(N.L)) !== '0' || kind(nativeVal(N.R)) !== '0' || busy) return upd('正在更新規格，請稍候再按一次加入購物車。');
        return { ok: true };
      }
      const v = eyesVal();
      if (!v.R || !v.L) return { ok: false, step: 'eyes', label: '請先選擇左右眼度數', m: '請選擇右眼與左眼的度數（沒有度數請選「平光（0）」）。', el: !v.R ? sel.R : sel.L };
      if (mode === 'my' && kind(v.R) === '0' && kind(v.L) === '0') return { ok: false, step: 'eyes', label: '請至少一眼選近視度數', m: '兩眼都是平光，請改選「平光」，或至少一眼選近視度數。', el: sel.R };
      const pe = pdErr(pdVal());
      if (pe) return { ok: false, step: 'pd', label: pdVal() === null || !Number.isFinite(pdVal()) ? '請先填瞳距 PD' : `PD 需在 ${PD_LO}–${PD_HI}mm`, m: pe, el: pdIn, pd: true };
      if (busy || nativeVal(N.L) !== v.L || nativeVal(N.R) !== v.R) return upd('正在更新規格，請稍候再按一次加入購物車。');
      if (!formId()) return { ok: false, step: 'eyes', label: '此度數組合無法下單', m: '目前的度數組合無法下單，請重新選擇左右眼度數。', el: sel.R };
      return { ok: true };
    }
    // 驗證：回傳 null 代表可加入購物車
    function validate() {
      const g = gateStatus();
      if (g.ok) return null;
      if (g.upd && !busy && mode !== 'plain') commitEyes();
      return { m: g.m, step: g.step, el: g.el, pd: g.pd };
    }
    (window.pxGate = window.pxGate || { items: [] }).items.push({ pid: String(pid), ids: [], status: () => { const g = gateStatus(); return g.ok ? g : { ok: false, label: g.label, msg: g.m, step: g.step }; }, block: (b) => { const err = validate(); if (err) showBlock(err, b); return !!err; } });
    function blockBtn(b) { if (!b || !b.classList) return; b.classList.remove('pxz-shake'); void b.offsetWidth; b.classList.add('pxz-shake'); setTimeout(() => b.classList.remove('pxz-shake'), 600); }
    function showBlock(err, b) {
      setErr(eerr, ''); pdInline('');
      if (err.step === 'color' || err.step === 'rx') { steps[err.step].gm.textContent = err.m; }
      else if (err.pd) pdInline(err.m); else if (err.step === 'eyes') { setErr(eerr, err.m); if (err.el) markInvalid(err.el, true); } else { setErr(eerr, err.m); }
      const key = err.step || 'eyes';
      if (steps[key] && !steps[key].hidden) setOpen(key);
      setTimeout(() => { const tgt = (err.el && err.el.closest('.pxz-fld')) || steps[key]; if (tgt) tgt.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' }); if (err.el) { try { err.el.focus({ preventScroll: true }); } catch (_) {} } }, 380);
      blockBtn(b);
    }
    function writeProps() {
      props.innerHTML = '';
      if (mode === 'plain') return;
      const pd = pdVal(); if (pd === null || !Number.isFinite(pd)) return;
      const fm = mainForm(); const fid = fm ? fm.getAttribute('id') : '';
      const i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[瞳距 PD]'; i.value = `${pd}mm`; if (fid) i.setAttribute('form', fid); props.appendChild(i);
    }
    // 加入購物車前檢查（擷取階段，擋在主題處理之前；主題用按鈕 click 而不是 submit）
    document.addEventListener('submit', (e) => {
      const fm = e.target; if (!(fm instanceof HTMLFormElement) || !fm.matches('form[action*="/cart/add"]')) return;
      const p = fm.querySelector('input[name="product-id"]') ? fm.querySelector('input[name="product-id"]').value : null;
      if (p && p !== pid) return;
      const err = validate();
      if (err) { e.preventDefault(); e.stopImmediatePropagation(); showBlock(err, fm.querySelector('button.add-to-cart-button')); } else writeProps();
    }, true);
    document.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target : null; if (!t) return;
      const b = t.closest('button.add-to-cart-button, shopify-accelerated-checkout, shopify-buy-it-now-button'); if (!b) return;
      const err = validate();
      if (err) { e.preventDefault(); e.stopImmediatePropagation(); showBlock(err, b); } else writeProps();
    }, true);

    // ---------- 事件 ----------
    function choose(c, advanceNow, viaKey) {
      const k = c.dataset.kind, val = c.dataset.val;
      if (GT[k] !== undefined) { GT[k] = true; steps[k].gm.textContent = ''; }
      if (k === 'color') { chooseColor(val); if (advanceNow) advance('rx', viaKey); }
      else if (k === 'rx') { chooseMode(val); if (advanceNow) advance(val === 'plain' ? null : 'eyes', viaKey); }
    }
    box.addEventListener('click', (e) => {
      const c = e.target.closest ? e.target.closest('.pxz-card') : null;
      if (c) { choose(c, true, e.detail === 0); return; }
      const j = e.target.closest ? e.target.closest('[data-jump]') : null;
      if (j) { e.preventDefault(); const calc = document.querySelector('[data-pxs-calc]'); if (calc) { calc.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }); try { calc.setAttribute('tabindex', '-1'); calc.focus({ preventScroll: true }); } catch (_) {} } return; }
      if (e.target === nextEyes) {
        const v = eyesVal(); let m = '', el = null;
        if (!v.R || !v.L) { m = '請選擇右眼與左眼的度數（沒有度數請選「平光（0）」）。'; el = !v.R ? sel.R : sel.L; }
        else if (mode === 'my' && kind(v.R) === '0' && kind(v.L) === '0') { m = '兩眼都是平光，請改選「平光」，或至少一眼選近視度數。'; el = sel.R; }
        if (m) { setErr(eerr, m); markInvalid(el, true); try { el.focus({ preventScroll: true }); } catch (_) {} blockBtn(nextEyes); }
        else { setErr(eerr, ''); advance('pd', e.detail === 0); }
        return;
      }
      if (e.target === doneBtn) {
        const m = pdErr(pdVal());
        if (m) { pdInline(m); try { pdIn.focus({ preventScroll: true }); } catch (_) {} blockBtn(doneBtn); }
        else { pdInline(''); advance(null, false); }
      }
    });
    // 卡片群組：方向鍵移動並選取（不自動跳下一步）
    box.addEventListener('keydown', (e) => {
      const c = e.target.closest ? e.target.closest('.pxz-card') : null; if (!c) return;
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'h', End: 'e' }; if (!(e.key in keys)) return;
      e.preventDefault();
      const cards = [...c.parentElement.querySelectorAll('.pxz-card')]; let i = cards.indexOf(c);
      i = keys[e.key] === 'h' ? 0 : keys[e.key] === 'e' ? cards.length - 1 : (i + keys[e.key] + cards.length) % cards.length;
      cards[i].focus(); choose(cards[i], false, true);
    });
    for (const e of ['R', 'L']) sel[e].addEventListener('change', () => { setErr(eerr, ''); markInvalid(sel.R, 0); markInvalid(sel.L, 0); render(); commitEyes(); });
    pdIn.addEventListener('beforeinput', (e) => { if (e.data && /[^0-9.]/.test(e.data)) e.preventDefault(); });
    pdIn.addEventListener('input', () => { if (pdEr.textContent) pdInline(pdErr(pdVal())); render(); });
    pdIn.addEventListener('change', () => { if (pdIn.value.trim() !== '') pdInline(pdErr(pdVal())); render(); });

    // ---------- 渲染 ----------
    function nativePrice() {
      const el = document.querySelector('.product-details product-price') || document.querySelector('product-price'); if (!el) return null;
      const m = el.textContent.match(/[\d][\d,]*(\.\d+)?/); return m ? Math.round(parseFloat(m[0].replace(/,/g, '')) * 100) : null;
    }
    function render() {
      const plain = mode === 'plain';
      const col = nativeVal(N.c) || '';
      let price = plain ? D.pricePlain : D.priceRx;
      const v = eyesVal();
      const inSync = !busy && (plain ? (kind(nativeVal(N.L)) === '0' && kind(nativeVal(N.R)) === '0') : (v.R && v.L && nativeVal(N.L) === v.L && nativeVal(N.R) === v.R));
      if (inSync) { const np = nativePrice(); if (np && np !== price) price = np; }
      // 卡片狀態
      const setChecked = (group, test) => { const cs = [...group.querySelectorAll('.pxz-card')]; let any = false; cs.forEach((c) => { const on = test(c); any = any || on; c.setAttribute('aria-checked', on ? 'true' : 'false'); c.tabIndex = on ? 0 : -1; }); if (!any && cs[0]) cs[0].tabIndex = 0; };
      setChecked(steps.color.inEl, (c) => c.dataset.val === col);
      setChecked(steps.rx.inEl, (c) => c.dataset.val === mode);
      steps.rx.inEl.querySelectorAll('.pxz-card').forEach((c) => { c.querySelector('[data-add]').textContent = c.dataset.val !== 'plain' && diff > 0 ? '+' + NT(diff) : ''; });
      steps.eyes.hidden = steps.pd.hidden = plain;
      if (plain && (openKey === 'eyes' || openKey === 'pd')) setOpen(null);
      // 摘要
      steps.color.sumEl.textContent = col ? cname(col) : '';
      steps.rx.sumEl.textContent = plain ? '平光（兩眼 0 度）' : (mode === 'hy' ? '遠視' : '近視');
      steps.rx.addEl.textContent = !plain && diff > 0 ? '+' + NT(diff) : '';
      const eyesOk = !!(v.R && v.L) && !(mode === 'my' && kind(v.R) === '0' && kind(v.L) === '0');
      const eyeTxt = eyesOk ? `右眼 ${short(v.R)}；左眼 ${short(v.L)}` : '';
      steps.eyes.sumEl.textContent = eyeTxt || '尚未選擇';
      const pv = pdVal(); const pdOk = pv !== null && !pdErr(pv);
      steps.pd.sumEl.textContent = pdOk ? `${pv}mm` : '尚未填寫';
      if (!GT.color) steps.color.sumEl.textContent = '尚未選擇'; if (!GT.rx) steps.rx.sumEl.textContent = '尚未選擇';
      steps.color.classList.toggle('is-set', !!col && GT.color); steps.rx.classList.toggle('is-set', GT.rx);
      steps.eyes.classList.toggle('is-set', eyesOk); steps.pd.classList.toggle('is-set', pdOk);
      // 合計
      total.querySelector('[data-cfg]').textContent = [col ? cname(col) : '', plain ? '平光' : (mode === 'hy' ? '遠視' : '近視')].filter(Boolean).join('・');
      total.querySelector('[data-eye]').textContent = !plain && eyeTxt ? eyeTxt + (pdOk ? `；PD ${pv}mm` : '') : '';
      const ls = [`<li><span>鏡框與鏡片${plain ? '（平光）' : '（平光基本價）'}</span><b>${NT(D.pricePlain)}</b></li>`];
      if (!plain && price > D.pricePlain) ls.push(`<li><span>${mode === 'hy' ? '遠視度數' : '近視度數'}</span><b>+${NT(price - D.pricePlain)}</b></li>`);
      total.querySelector('[data-ls]').innerHTML = ls.join('');
      total.querySelector('[data-sum]').textContent = NT(price);
      total.dataset.price = String(price);
      total.dataset.mode = mode;
    }
    fillSelects(); setOpen('color'); render();
    // 監聽原生選項變化：驗光單換算工具、網址帶入的變體
    setInterval(() => { if (busy) return; const s = sig(); if (s !== lastSig) { lastSig = s; adoptFromNative(); } render(); }, 300);
    document.addEventListener('pxs:applied', async () => {
      GT.rx = true;
      await sleep(900); adoptFromNative(); lastSig = sig(); render();
      const first = !steps.pd.hidden && !(pdVal() !== null && !pdErr(pdVal())) ? 'pd' : null;
      setOpen(first); box.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
    });
    return true;
  }
  const boot = () => document.querySelectorAll('[data-pxs]').forEach((r) => { if (!r.id) r.id = 'pxs-' + Math.random().toString(36).slice(2, 7); if (cfg(r)) return; let n = 0; const iv = setInterval(() => { if (cfg(r) || ++n > 40) clearInterval(iv); }, 250); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
